/**
 * BGGAPIClient - Calls the backend proxy for BoardGameGeek API requests.
 * The proxy (server.js) handles XML→JSON conversion.
 */

const BACKEND_PROXY = (
    import.meta.env.VITE_PROXY_URL || 'http://localhost:4005'
).replace(/\/+$/, '');

/**
 * Search BGG for board games by query string.
 * @param {string} query - Search term
 * @returns {Promise<Array>} Array of { bggId, name, yearPublished }
 */
export async function searchBoardgames(query) {
    const res = await fetch(`${BACKEND_PROXY}/api/bgg/search?query=${encodeURIComponent(query)}`);
    if (!res.ok) throw new Error(`BGG search failed: ${res.status}`);
    const data = await res.json();
    return data.items || [];
}

/**
 * Fetch full details for a board game by BGG ID.
 * @param {string} bggId - BoardGameGeek game ID
 * @returns {Promise<Object>} Full game details
 */
export async function getBoardgameDetails(bggId) {
    const res = await fetch(`${BACKEND_PROXY}/api/bgg/thing/${bggId}`);
    if (!res.ok) throw new Error(`BGG details failed: ${res.status}`);
    return res.json();
}
